import { render, staticRenderFns } from "./bp-submit-dialog.vue?vue&type=template&id=238a96e1&"
import script from "./bp-submit-dialog.vue?vue&type=script&lang=ts&"
export * from "./bp-submit-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports